<template id="pagination">
  <ul class="pagination" aria-label="Page navigation">
    <li>
      <button
        type="button"
        @click="onClickFirstPage"
        :disabled="isInFirstPage"
        aria-label="Go to the first page"
      >
        First
      </button>
    </li>
    <li>
      <button
        type="button"
        @click="onClickPreviousPage"
        :disabled="isInFirstPage"
        aria-label="Previous"
      >
        «
      </button>
    </li>
    <li v-for="page in pages" :key="page.id">
      <button
        type="button"
        @click="onClickPage(page.name)"
        :disabled="page.isDisabled"
        :class="{ active: isPageActive(page.name) }"
        :aria-label="`Go to page number ${page.name}`"
      >
        {{ page.name }}
      </button>
    </li>
    <li>
      <button
        type="button"
        @click="onClickNextPage"
        :disabled="isInLastPage"
        aria-label="Next"
      >
        »
      </button>
    </li>
    <li>
      <button
        type="button"
        @click="onClickLastPage"
        :disabled="isInLastPage"
        aria-label="Go to the last page"
      >
        Last
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 10,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isInFirstPage: function() {
      return this.currentPage === 1;
    },
    isInLastPage: function() {
      return this.currentPage === this.totalPages;
    },
    startPage: function() {
      if (this.currentPage === 1) {
        return 1;
      }
      if (this.currentPage === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons + 1;
      }
      return this.currentPage - 1;
    },
    endPage: function() {
      return Math.min(
        this.startPage + this.maxVisibleButtons - 1,
        this.totalPages
      );
    },
    pages: function() {
      const range = [];
      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage,
        });
      }
      return range;
    },
  },
  methods: {
    onClickFirstPage: function() {
      this.$emit("pagechanged", 1);
    },
    onClickPreviousPage: function() {
      this.$emit("pagechanged", this.currentPage - 1);
    },
    onClickPage: function(page) {
      this.$emit("pagechanged", page);
    },
    onClickNextPage: function() {
      this.$emit("pagechanged", this.currentPage + 1);
    },
    onClickLastPage: function() {
      this.$emit("pagechanged", this.totalPages);
    },
    isPageActive: function(page) {
      return this.currentPage === page;
    },
  },
};
</script>

<style scoped>
.pagination {
  margin: 0;
  padding: 0;
  list-style: none outside none;
  display: flex;
  justify-content: end;
  align-items: end;
}

li {
  margin: 0 4px;
  padding: 0;
  list-style: none outside none;
  line-height: 25px;
}
button {
  display: block;
  border: none 0;
  color: #414146;
  background-color: #fff;

  padding: 5px 13px;
  border-radius: 2px;

  text-decoration: none;
  cursor: pointer;
}

button.active {
  text-decoration: none;
  background-color: #14bef0;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/Pagination.vue